// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3TSJe","dragIcon":"SortableItem_dragIcon__cguYU","disabled":"SortableItem_disabled__1A9_g"};